import { render, staticRenderFns } from "./IconOsnovaLogo.vue?vue&type=template&id=f4a35b0e&"
import script from "./IconOsnovaLogo.vue?vue&type=script&lang=js&"
export * from "./IconOsnovaLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4a35b0e')) {
      api.createRecord('f4a35b0e', component.options)
    } else {
      api.reload('f4a35b0e', component.options)
    }
    module.hot.accept("./IconOsnovaLogo.vue?vue&type=template&id=f4a35b0e&", function () {
      api.rerender('f4a35b0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/IconOsnovaLogo.vue"
export default component.exports